<template>
  <div v-click-outside="onClickOutside" class="content-center">
    <div class="top">
      <div class="left">
        <div class="htd">
          <img src="@/assets/Mobile/images/home/home_htd.png" alt="">
        </div>
      </div>
      <div class="right">
        <img v-if="!open" src="@/assets/Mobile/images/home/home_more.png" class="more" @click="open=true">
        <img v-else src="@/assets/Mobile/images/home/close.png" class="close" @click="open=false">
      </div>
    </div>
    <a-menu
      v-show="open"
      theme="dark"
      class="sk-mobile-menu"
      :default-selected-keys="['1']"
      :open-keys="openKeys"
      mode="inline"
      @openChange="onOpenChange"
    >
      <a-menu-item key="index" @click="linkTo('index')">首页</a-menu-item>
      <a-menu-item key="aboutUs" @click="linkTo('aboutUs')">关于我们</a-menu-item>
      <a-menu-item key="finance" @click="linkTo('finance')">新闻中心</a-menu-item>
      <a-menu-item key="visian" @click="linkTo('visian')">投资者关系</a-menu-item>
      <a-menu-item key="cooperate" @click="linkTo('cooperate')">联系方式</a-menu-item>
      <!-- <a-menu-item key="eco-partner" @click="linkTo('eco-partner')">汇通达商城</a-menu-item> -->
    </a-menu>
    <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="B2B2C" @cancel="modalClose" />
  </div>
</template>

<script>
import TryModal from '@/Mobile/Mobilecom/TryModal'
import vClickOutside from 'v-click-outside'
export default {
  components: {
    TryModal
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      rootSubmenuKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7'],
      openKeys: [],
      selectedKeys: [],
      open: false,
      tryVisible: false,
      showRight: true
    }
  },
  watch: {
    '$route'(to, from) {
      if (['/m/introduce', '/m/dynamic'].indexOf(to.path) !== -1) {
        this.showRight = false
      }
    },
    open(val, oldval) {
      document.getElementsByTagName('body')[0].style.overflow = val ? 'hidden' : 'unset'
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    linkTo(path) {
      if (path === 'eco-partner') location.href = 'https://mall.htd.cn/login?redirectUrl=/'
      if (path === 'visian') {
        location.href = 'http://htd.vislan.com/'
        return
      }
      this.$router.push({ path: '/' + path })
      this.$nextTick(() => {
        this.open = false
      })
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        if (latestOpenKey === 'sub2' || latestOpenKey === 'sub3' || latestOpenKey === 'sub4' || latestOpenKey === 'sub5') {
          this.openKeys = ['sub1', latestOpenKey]
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : []
        }
      }
    },
    openModal: function() {
      this.tryVisible = true
    },
    modalClose: function(data) {
      this.tryVisible = data
    },
    toRegister: function() {
      window.location.href = 'https://mall.htd.cn/zc/#/beforePage?type=h5'
    },
    onClickOutside: function(event) {
      this.open = false
    }
  }
}
</script>

<style lang="less" scoped>
  .content-center {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #ff7700;
    z-index: 99;
    .top {
      display: flex;
      width: 100%;
      height: 50px;
      padding: 0 13px;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        .htd {
          padding-right: 13px;
          img {
            width: 73px;
          }
        }
        .htsk {
          padding-left: 13px;
          img {
            width: 80px;
          }
        }
      }
      .right {
        .more {
          width: 19px;
          height: 15px;
        }
        .close {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .sk-mobile-menu {
    width: 100%;
    position: fixed;
    top: 50px;
    text-align: left;
    max-height: calc(100% - 50px);
    overflow: auto;
    z-index: 99;
  }
  .free {
    position: fixed;
    display: inline-block;
    margin: 0;
    bottom: 60px;
    right: 0;
    width: 72px;
    height: 72px;
    z-index: 60;
    background: url("~@/assets/Mobile/images/home/conact.png") no-repeat center;
    background-size: 100%;
  }
  .conact {
    position: fixed;
    bottom: 150px;
    right: 0;
    width: 72px;
    height: 72px;
    z-index: 60;
  }
  /deep/ .ant-menu.ant-menu-dark .ant-menu-item-selected {
    background-color: unset;
    font-size: 14px;
    font-weight: 400;
    color: #ed7700;
  }
</style>
